import React, { Fragment } from 'react';
import MultiSelectBox from '../../../Common/MultiSelectBox/MultiSelectBox';
import Icon from '../../../Common/Icon';
import { TruncateText } from '../../../../helpers/strings';
import { DependenciesComponentProps } from '../../Interfaces/PropTypes';

export const DependenciesComponentForm = ({
	currentTask,
	onFormChange,
	searchPrereqTasks,
	taskPrereqSearchResults,
	onPrereqChange,
	onRemovePrereq,
	searchTasks,
	taskSearchResults,
	onContingentChange,
}: DependenciesComponentProps) => {
	const onPrereqSearchKeyDown = (e) => {
		switch (e.keyCode) {
			case 13: // enter
				e.preventDefault();
				if (e.target.defaultValue && e.target.defaultValue.length >= 3) {
					searchPrereqTasks(e.target.defaultValue);
				}
				break;
		}
	};

	const onTaskSearchKeyDown = (e) => {
		switch (e.keyCode) {
			case 13: // enter
				e.preventDefault();
				if (e.target.defaultValue && e.target.defaultValue.length >= 3) {
					searchTasks(e.target.defaultValue);
				}
				break;
		}
	};

	const onSuccessorAdd = (id) => {
		// when a contingent is selected
		// for some reason calling onFormChange twice here didn't update the object in the controller correctly
		const contingentName = taskSearchResults.find((m) => m.id === id).name;
		//console.log(contingentName);
		onContingentChange(id, contingentName);
	};

	const onDropdownChange = (value: number, name: string) => {
		onFormChange(name, value);
	};

	return (
		<Fragment>
			<div className='col-6'>
				<div className='mb-3'>
					<label htmlFor='communityId' className='title'>
						Pre-Requisite Task&nbsp;&nbsp;<i className='fa-regular fa-info-circle fa-lg'></i>
					</label>
					<MultiSelectBox
						name='prereqTasks'
						idField='id'
						valueField='name'
						options={taskPrereqSearchResults?.length > 0 ? taskPrereqSearchResults : []}
						placeholder='Start typing or select pre-requisite task'
						//selectedValues={taskData.taskManagerId === 0 ? '' : taskData.taskManagerId.toString()}
						selectedValues={''}
						onChange={onPrereqChange}
						isMulti={false}
						onInputKeyDown={onPrereqSearchKeyDown}
						onKeyDown={onPrereqSearchKeyDown}
						value={currentTask.prereqTasks?.toString()}
					/>
					{currentTask.prereqTasks && currentTask.prereqTasks.length > 0 && (
						<div className='alert alert-secondary contingent-alert'>
							<div>
								This task has the following pre-requisites:
								{currentTask.prereqTasks.map((prereq) => {
									return (
										<div className='col-12' key={prereq.id}>
											<span className='me-2 remove' onClick={() => onRemovePrereq(prereq.id)}>
												<Icon name='times' />
											</span>
											{/* PENDING IMPLEMENTATION showRelationshipDrawer  */}
											<a href='#' onClick={() => console.log(prereq.id)}>
												{TruncateText(prereq.name, 80)}
											</a>
										</div>
									);
								})}
							</div>
						</div>
					)}
				</div>
			</div>
			<div className='col-6'>
				<div className='mb-3'>
					<label htmlFor='task-name' className='title'>
					Successor Task&nbsp;&nbsp;<i className='fa-regular fa-info-circle fa-lg'></i>
					</label>
					<MultiSelectBox
						name='contingentId'
						idField='id'
						valueField='name'
						options={taskSearchResults?.length > 0 ? taskSearchResults : []}
						placeholder='Start typing or select successor'
						//selectedValues={taskData.taskManagerId === 0 ? '' : taskData.taskManagerId.toString()}
						selectedValues={''}
						isMulti={false}
						onInputKeyDown={onTaskSearchKeyDown}
						onChange={onSuccessorAdd}
					/>
				</div>
			</div>
		</Fragment>
	);
};
